<p-confirmDialog></p-confirmDialog>


<div class="form-container" [formGroup]="jobForm">

    
<!-- PAGE -->
<div class="page-wrapper">


  <!-- STEP INDICATOR -->
  <div class="steps-bar">
    <div class="step-item">
      <div class="step-circle " [ngClass]="jobForm.get('truckId')?.value ? 'active' : 'pending'">1</div>
      <div class="step-info" [ngClass]="jobForm.get('truckId')?.value ? 'active' : 'pending'">
        <div class="step-num">Step 01</div>
        <div class="step-label">Truck Info</div>
      </div>
    </div>
    <ng-container *ngIf="selectedTruck?.isHorse">
    <div class="step-connector " [ngClass]="jobForm.get('trailerId')?.value ? 'active' : 'pending'"></div>
    <div class="step-item">
      <div class="step-circle" [ngClass]="jobForm.get('trailerId')?.value ? 'active' : 'pending'">2</div>
      <div class="step-info" [ngClass]="jobForm.get('trailerId')?.value ? 'active' : 'pending'">
        <div class="step-num">Step 02</div>
        <div class="step-label">Trailer</div>
      </div>
    </div>
    </ng-container>
    <div class="step-connector " [ngClass]="jobForm.get('batteryListAdd')?.value?.length > 0 && jobForm.get('tyreListAdd')?.value?.length > 0 ? 'active' : 'pending'"></div>
    <div class="step-item">
      <div class="step-circle" [ngClass]="jobForm.get('batteryListAdd')?.value?.length > 0 && jobForm.get('tyreListAdd')?.value?.length > 0 ? 'active' : 'pending'">2</div>
      <div class="step-info" [ngClass]="jobForm.get('batteryListAdd')?.value?.length > 0 && jobForm.get('tyreListAdd')?.value?.length > 0 ? 'active' : 'pending'">
        <div class="step-num">Step {{selectedTruck?.isHorse ? '03':'02'}}</div>
        <div class="step-label">Tyres & Battery</div>
      </div>
    </div>
    <div class="step-connector" [ngClass]="jobForm.get('pollutionId')?.value ? 'active' : 'pending'"></div>
    <div class="step-item">
      <div class="step-circle " [ngClass]="jobForm.get('pollutionId')?.value ? 'active' : 'pending'">3</div>
      <div class="step-info " [ngClass]="jobForm.get('pollutionId')?.value ? 'active' : 'pending'">
        <div class="step-num">Step {{selectedTruck?.isHorse ? '04':'03'}}</div>
        <div class="step-label">Compliance</div>
      </div>
    </div>
    <div class="step-connector" [ngClass]="jobForm.get('vendorId')?.value ? 'active' : 'pending'"></div>
    <div class="step-item">
      <div class="step-circle" [ngClass]="jobForm.get('vendorId')?.value ? 'active' : 'pending'">4</div>
      <div class="step-info" [ngClass]="jobForm.get('vendorId')?.value ? 'active' : 'pending'">
        <div class="step-num">Step {{selectedTruck?.isHorse ? '05':'04'}}</div>
        <div class="step-label">Dealer Info</div>
      </div>
    </div>
    <div class="step-connector"></div>
    <div class="step-item">
      <div class="step-circle pending">5</div>
      <div class="step-info pending">
        <div class="step-num">Step {{selectedTruck?.isHorse ? '06':'05'}}</div>
        <div class="step-label">Review & Submit</div>
      </div>
    </div>
  </div>

  <div class="" [ngClass]="selectedTruck?.isHorse ? 'two-col-sections':''">
  <!-- ══════════════════════════════════════ -->
  <!-- SECTION 1: TRUCK INFO -->
  <!-- ══════════════════════════════════════ -->
  <div class="section-card">
    <div class="section-header">
      <div class="section-title">
        <div class="section-icon truck">🚛</div>
        <div>
          <h2>Truck Information</h2>
          <div class="section-subtitle">Select truck from master and capture core details</div>
        </div>
      </div>
      <span class="section-badge badge-required">Required</span>
    </div>
    <div class="section-body" >
      <div class="form-grid grid-3">
        <!-- Truck Number -->
        <div class="field">
          <label class="field-label">Truck Number <span class="required-dot">*</span></label>
          <div class="">
            <ng-select (change)="onTruckChange($event)" appendTo="body" formControlName="truckId" placeholder="Select " class="field-input filled">
                <ng-option *ngFor="let item of truckList" [value]="item.id">{{item.truckNumber}}</ng-option>
            </ng-select>
          </div>
        </div>

        <div class="field">
          <label class="field-label">Brand</label>
          <div class="field-input">
            <input type="text" trim="blur" class="read-only-field" formControlName="brandModel" readonly />
          </div>
        </div>

        <!-- Truck Type -->
        <div class="field">
          <label class="field-label">Truck Model</label>
          <div class="field-input">
            <input type="text" trim="blur" class=" read-only-field" formControlName="truckType" readonly />
          </div>
        </div>
      </div>

      <hr class="divider">

      <div class="form-grid grid-3">
        <div class="field">
          <label class="field-label">Manufacturing Date</label>
          <div class="field-input">
            <input type="text" trim="blur" class="read-only-field" formControlName="manufacturingDate" readonly />
          </div>
        </div>

        <!--  Onboarded Date -->
        <div class="field">
          <label class="field-label">Onboarded Date</label>
          <div class="field-input">
            <input type="text" trim="blur" class="read-only-field" formControlName="onboardedDate" readonly />
          </div>
        </div>
      </div>

     
    </div>
  </div>

    <!-- ══════════════════════════════════════ -->
  <!-- SECTION 1: Trailer INFO -->
  <!-- ══════════════════════════════════════ -->
  <div class="section-card" *ngIf="selectedTruck?.isHorse">
    <div class="section-header">
      <div class="section-title">
        <div class="section-icon truck">🚌</div>
        <div>
          <h2>Trailer Information</h2>
          <div class="section-subtitle">Link and configure the trailer attached to this truck</div>
        </div>
      </div>
      <!-- <span class="section-badge badge-required">Required</span> -->
    </div>
    <div class="section-body">
      <div class="form-grid grid-3">
        <!-- Truck Number -->
        <div class="field">
          <label class="field-label">Trailer Number<span class="required-dot">*</span></label>
          <div class="">
            <ng-select (change)="onTrailerChange($event)" appendTo="body" formControlName="trailerId" placeholder="Select " class="field-input filled">
                <ng-option *ngFor="let item of trailerList" [value]="item.id">{{item.fleetNumber}}</ng-option>
            </ng-select>
          </div>
        </div>

        <div class="field">
          <label class="field-label">Trailer Type</label>
          <div class="field-input">
            <input type="text" trim="blur" class="read-only-field" formControlName="trailerType" readonly />
          </div>
        </div>
        <div class="field">
          <label class="field-label">Manufacturing Date</label>
          <div class="field-input">

            <input type="text" trim="blur" class="read-only-field" formControlName="manufacturingTrailerDate" readonly />
          </div>
        </div>
        <!-- Truck Type -->
        <!-- <div class="field">
          <label class="field-label">Trailer Capacity (Tyres)</label>
          <div class="field-input">
            <span class="read-only-field" >
              <ng-container *ngIf="selectedTrailer">
                <span style="color: #666;font-size: 8px;margin-right: 5px;"> Max allowed</span>
                <b>{{selectedTrailer?.trailerTyreCapacity}} Tyre</b>
              </ng-container>
            </span>

          </div>
        </div> -->
      </div>

      <hr class="divider">

      <div class="form-grid grid-3">
       

        <!--  Onboarded Date -->
        <div class="field">
          <label class="field-label">Onboarded Date<span class="required-dot">*</span></label>
          <div class="field-input">
            <p-calendar appendTo="body" class="mfgDate"  formControlName="trailerFromDate" dateFormat="dd/mm/yy" [maxDate]="maxDate" [minDate]="selectedTruck?.purchaseDateObjNew"></p-calendar>
            <!-- <input type="text" trim="blur" class="read-only-field" formControlName="onboardedDate" readonly /> -->
          </div>
        </div>
        <!-- <div class="field">
          <label class="field-label">Trailer Tyre Count</label>
          <div class="field-input">
             <span class="read-only-field" >
            <ng-container *ngIf="selectedTrailer">
                <span style="color: #666;font-size: 8px;margin-right: 5px;"> Currently assigned</span>
                <b>{{selectedTyreTrailer.length}} / {{selectedTrailer?.trailerTyreCapacity}}</b>
              </ng-container>
              </span>
          </div>
        </div> -->
      </div>

      <!-- <hr class="divider"> -->

     
    </div>
  </div>
</div>

<div class="section-card">
  <div class="section-body">
 <!-- Capacity Chips -->
      <div style="margin-bottom: 8px;">
        <!-- <div class="field-label" style="margin-bottom: 8px;">Truck Capacity (From Master)</div> -->
        <div class="capacity-row">
          <div class="capacity-item">
            <div class="cap-icon">🔘</div>
            <div class="cap-info">
              <div class="cap-label">Truck Tyre Capacity</div>
              <div class="cap-count">{{selectedTruck?.tyreCapacity}}</div>
              <div class="cap-sub">Max tyres allowed</div>
            </div>
            <div style="flex:1">
              <div style="font-size:10px;color:var(--text-muted);margin-bottom:4px;font-family:var(--mono)">{{selectedTyre?.length}} / {{selectedTruck?.tyreCapacity}} selected</div>
              <div class="progress-bar"><div class="progress-fill fill-tyre" [style.width.%]="selectedTruck?.tyreCapacity ? (selectedTyre.length / selectedTruck.tyreCapacity) * 100 : 0"></div></div>
            </div>
          </div>
          <div class="capacity-item" *ngIf="selectedTruck?.isHorse">
            <div class="cap-icon">🔘</div>
            <div class="cap-info">
              <div class="cap-label">Trailer Tyre Capacity</div>
              <div class="cap-count">{{selectedTrailer?.trailerTyreCapacity}}</div>
              <div class="cap-sub">Max tyres allowed</div>
            </div>
            <div style="flex:1">
              <div style="font-size:10px;color:var(--text-muted);margin-bottom:4px;font-family:var(--mono)">{{selectedTyreTrailer?.length}} / {{selectedTrailer?.trailerTyreCapacity}} selected</div>
              <div class="progress-bar"><div class="progress-fill fill-tyre" [style.width.%]="selectedTrailer?.trailerTyreCapacity ? (selectedTyreTrailer.length / selectedTrailer?.trailerTyreCapacity) * 100 : 0"></div></div>
            </div>
          </div>
          <div class="capacity-item">
            <div class="cap-icon">🔋</div>
            <div class="cap-info">
              <div class="cap-label">No of Battery</div>
              <div class="cap-count">{{selectedTruck?.batteryCapacity}}</div>
              <div class="cap-sub">Max batteries allowed</div>
            </div>
            <div style="flex:1">
              <div style="font-size:10px;color:var(--text-muted);margin-bottom:4px;font-family:var(--mono)">{{selectedBatteries.length}} / {{selectedTruck?.batteryCapacity}} selected</div>
              <div class="progress-bar"><div class="progress-fill fill-battery" [style.width.%]="selectedTruck?.batteryCapacity ? (selectedBatteries.length / selectedTruck.batteryCapacity) * 100 : 0"></div></div>
            </div>
          </div>
          <div class="capacity-item" style="flex:none;min-width:280px;">
            <div class="cap-icon">🟢</div>
            <div class="cap-info">
              <div class="cap-label">Assembly Status</div>
              <div class="cap-count" style="font-size:14px;color:var(--orange)">In Progress</div>
              <div class="cap-sub">Truck: {{selectedTyre.length}} | Trailer: {{selectedTyreTrailer.length}} | Battery: {{selectedBatteries.length}}</div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>


  <!-- ══════════════════════════════════════ -->
  <!-- SECTION 2 & 3: TYRE + BATTERY (side by side) -->
  <!-- ══════════════════════════════════════ -->
  <div class="" [ngClass]="selectedTruck?.isHorse ? 'three-col-sections':'two-col-sections'">
    <!-- TYRE INFO -->
    <div class="section-card" style="margin-bottom:0">
      <div class="section-header">
        <div class="section-title">
          <div class="section-icon battery">🔘</div>
          <div>
            <h2>Truck Tyre Information</h2>
            <div class="section-subtitle">Multi-select serial numbers</div>
          </div>
        </div>
        <span class="section-badge badge-count">{{selectedTyre.length}} / {{selectedTruck?.tyreCapacity}}</span>
      </div>
      <div class="section-body">
        <!-- Battery Selection -->
         <div class="field"  style="margin-bottom:14px;">
            <label class="field-label">Tyre Number <span class="required-dot">*</span> </label>
            <div class="">
              <ng-select appendTo="body" formControlName="tyreListAdd" placeholder="+ Add Tyre... " class="field-input filled" [multiple]="true"
              [closeOnSelect]="false" (change)="onTyreSelect($event)">
                  <ng-option *ngFor="let item of tyreList" [value]="item">{{item.serialNumber}} ({{item.isNew == true ? 'New': 'Old'}})</ng-option>
              </ng-select>
            </div>
          </div>
          
        <!-- <div class="field" style="margin-bottom:14px;">
          <label class="field-label">Select Battery Serial Numbers</label>
          <div class="multi-select-box">
            <span class="tag" style="background:#FEF3E8;color:#C95F0A;">BAT-2312 <span class="remove">✕</span></span>
            <span class="tag-placeholder">+ Add battery...</span>
          </div>
          <div class="field-hint">Max 2 batteries for this truck</div>
        </div> -->

        <!-- Auto-populated fields -->
        <div class="form-grid grid-2" style="margin-bottom:14px;">
          <div class="field">
            <label class="field-label">Brand &amp; Model</label>
            <div class="info-chip">
                <span class="">
                  <!-- {{ getTyreBrandList() }} -->
                  {{tyreBrandDisplay}}
                </span>
            </div>
         </div>

          
          <div class="field">
            <label class="field-label">Total Count</label>
            <div class="info-chip">
              <span class="chip-label">Selected</span>
              <span class="chip-value">{{ selectedTyre.length }} Tyre</span>
            </div>
          </div>
        </div>

        <div class="button-container mb-3">
          <!-- <button class="assign-button w-100 justify-content-center btn btn-primary" [ngClass]="{disabled: selectedTyre.length==0}" [disabled]="selectedTyre.length==0" (click)="assignTyrePosition('Add',selectedTyre,'truck')">
              <svg width="16" height="16" class="pin-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2C7.58 2 4 5.58 4 10c0 5.25 8 12 8 12s8-6.75 8-12c0-4.42-3.58-8-8-8zm0 11c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"/>
              </svg>
              <span>Assign Tyre Positions</span>
              <span class="arrow">→</span>
          </button> -->

          <button class="assign-button w-100 justify-content-center btn btn-primary" [ngClass]="{disabled: selectedTyre.length==0}" [disabled]="selectedTyre.length==0" (click)="assignTyrePositionNew('Add',selectedTyre,'truck')">
              <svg width="16" height="16" class="pin-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2C7.58 2 4 5.58 4 10c0 5.25 8 12 8 12s8-6.75 8-12c0-4.42-3.58-8-8-8zm0 11c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"/>
              </svg>
              <span>Assign Tyre Positions</span>
              <span class="arrow">→</span>
          </button>

        </div>
        <!-- Battery Health Table -->
        <div class="field-label" style="margin-bottom: 8px;">Tyre Health Details</div>
        <div class="table-scroll"  >
          <table class="health-table">
            <thead>
              <tr>
                <th>Serial No.</th>
                <th>Mfg. Date</th>
                <th>KMs Run</th>
                <!-- <th>Brand</th> -->
                <!-- <th>Status</th> -->
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="selectedTyre.length > 0">
              <tr *ngFor="let battery of selectedTyre">
                <td>{{ battery.serialNumber }}</td>
                <td>{{ battery.mfgDate | CustomDatePipe: 'D-M-YYYY' }}</td>
                <td>{{ battery.initialKmTravelled }}</td>
                <!-- <td>{{ battery.brandName}}</td> -->
                <!-- <td>{{ battery.status }}</td> -->
              </tr>
              </ng-container>
              <tr *ngIf="selectedTyre.length == 0">
                <td colspan="5" style="text-align:center;color:var(--text-muted);padding:16px;font-family:var(--sans);">
                  <span style="font-size:20px;">🛞</span><br>
                  <span style="font-size:12px;">select a Tyre above</span>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <button class="add-row-btn">＋ Select another Tyre</button> -->
        </div>
      </div>
    </div>
    <!-- TYRE INFO -->
    <div class="section-card" style="margin-bottom:0" *ngIf="selectedTruck?.isHorse">
      <div class="section-header">
        <div class="section-title">
          <div class="section-icon battery">🔘</div>
          <div>
            <h2>Trailer Tyre Information</h2>
            <div class="section-subtitle">Multi-select serial numbers</div>
          </div>
        </div>
        <span class="section-badge badge-count">{{selectedTyreTrailer.length}} / {{selectedTrailer?.trailerTyreCapacity}}</span>
      </div>
      <div class="section-body">
        <!-- Battery Selection -->
         <div class="field"  style="margin-bottom:14px;">
            <label class="field-label">Tyre Number <span class="required-dot">*</span> </label>
            <div class="">
              <ng-select appendTo="body" formControlName="trailerListAdd" placeholder="+ Add Tyre... " class="field-input filled" [multiple]="true"
              [closeOnSelect]="false" (change)="onTrailerTyreChange($event)">
                  <ng-option *ngFor="let item of trailertyreList" [value]="item">{{item.serialNumber}} ({{item.isNew == true ? 'New': 'Old'}})</ng-option>
              </ng-select>
            </div>
          </div>
          
        <!-- <div class="field" style="margin-bottom:14px;">
          <label class="field-label">Select Battery Serial Numbers</label>
          <div class="multi-select-box">
            <span class="tag" style="background:#FEF3E8;color:#C95F0A;">BAT-2312 <span class="remove">✕</span></span>
            <span class="tag-placeholder">+ Add battery...</span>
          </div>
          <div class="field-hint">Max 2 batteries for this truck</div>
        </div> -->

        <!-- Auto-populated fields -->
        <div class="form-grid grid-2" style="margin-bottom:14px;">
          <div class="field">
            <label class="field-label">Brand &amp; Model</label>
            <div class="info-chip">
                <span class="">{{ getTrailerBrandList() }}</span>
            </div>
         </div>

          
          <div class="field">
            <label class="field-label">Total Count</label>
            <div class="info-chip">
              <span class="chip-label">Selected</span>
              <span class="chip-value">{{ selectedTyreTrailer.length }} Tyre</span>
            </div>
          </div>
        </div>

        <div class="button-container mb-3">
          <button class="assign-button w-100 justify-content-center btn btn-primary" [ngClass]="{disabled: selectedTyreTrailer.length==0}" [disabled]="selectedTyreTrailer.length==0" (click)="assignTrailerTyrePositionNew('Add',selectedTyreTrailer,'trailer')">
              <svg width="16" height="16" class="pin-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2C7.58 2 4 5.58 4 10c0 5.25 8 12 8 12s8-6.75 8-12c0-4.42-3.58-8-8-8zm0 11c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"/>
              </svg>
              <span>Assign Tyre Positions</span>
              <span class="arrow">→</span>
          </button>
        </div>

        <!-- Battery Health Table -->
        <div class="field-label" style="margin-bottom: 8px;">Tyre Health Details</div>
        <div class="table-scroll"  >
          <table class="health-table">
            <thead>
              <tr>
                <th>Serial No.</th>
                <th>Mfg. Date</th>
                <th>KMs Run</th>
                <!-- <th>Brand</th> -->
                <!-- <th>Status</th> -->
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="selectedTyreTrailer.length > 0">
              <tr *ngFor="let battery of selectedTyreTrailer">
                <td>{{ battery.serialNumber }}</td>
                <td>{{ battery.mfgDate | CustomDatePipe: 'D-M-YYYY' }}</td>
                <td>{{ battery.initialKmTravelled }}</td>
                <!-- <td>{{ battery.brandName}}</td> -->
                <!-- <td>{{ battery.status }}</td> -->
              </tr>
              </ng-container>
              <tr *ngIf="selectedTyreTrailer.length == 0">
                <td colspan="5" style="text-align:center;color:var(--text-muted);padding:16px;font-family:var(--sans);">
                  <span style="font-size:20px;">🛞</span><br>
                  <span style="font-size:12px;">select a Tyre above</span>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <button class="add-row-btn">＋ Select another Tyre</button> -->
        </div>
      </div>
    </div>

    <!-- BATTERY INFO -->
    <div class="section-card" style="margin-bottom:0">
      <div class="section-header">
        <div class="section-title">
          <div class="section-icon battery">🔋</div>
          <div>
            <h2>Battery Information</h2>
            <div class="section-subtitle">Multi-select serial numbers</div>
          </div>
        </div>
        <span class="section-badge badge-count">{{selectedBatteries.length}} / {{selectedTruck?.batteryCapacity}}</span>
      </div>
      <div class="section-body">
        <!-- Battery Selection -->
         <div class="field"  style="margin-bottom:14px;">
            <label class="field-label">Select Battery Serial Numbers <span class="required-dot">*</span></label>
            <div class="">
              <ng-select appendTo="body" formControlName="batteryListAdd" placeholder="+ Add battery... " class="field-input filled" [multiple]="true"
              [closeOnSelect]="false" (change)="onBatterySelect($event)">
                  <ng-option *ngFor="let item of batteryList" [value]="item">{{item.serialNumber}}</ng-option>
              </ng-select>
            </div>
          </div>

        <!-- Auto-populated fields -->
        <div class="form-grid grid-2" style="margin-bottom:14px;">
          <div class="field">
            <label class="field-label">Brand &amp; Model</label>
            <div class="info-chip">
                <span class="">{{ getBrandModelList() }}</span>
            </div>
         </div>
          
          <div class="field">
            <label class="field-label">Total Count</label>
            <div class="info-chip">
              <span class="chip-label">Selected</span>
              <span class="chip-value">{{ selectedBatteries.length }} Battery</span>
            </div>
          </div>
        </div>

        <!-- Battery Health Table -->
        <div class="field-label" style="margin-bottom: 8px;">Battery Health Details</div>
        <div class="table-scroll" >
          <table class="health-table">
            <thead>
              <tr>
                <th>Serial No.</th>
                <th>Mfg. Date</th>
                <th>KMs Run</th>
                <!-- <th>Brand</th> -->
                <!-- <th>Status</th> -->
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="selectedBatteries.length > 0">
              <tr *ngFor="let battery of selectedBatteries">
                <td>{{ battery.serialNumber }}</td>
                <td>{{ battery.mfgDate | CustomDatePipe: 'D-M-YYYY' }}</td>
                <td>{{ battery.initialKmTravelled }}</td>
                <!-- <td>{{ battery.brandName }}</td> -->
                <!-- <td>{{ battery.status }}</td> -->
              </tr>
              </ng-container>
              <tr *ngIf="selectedBatteries.length == 0">
                <td colspan="5" style="text-align:center;color:var(--text-muted);padding:16px;font-family:var(--sans);">
                  <span style="font-size:20px;">🔋</span><br>
                  <span style="font-size:12px;">Select a battery above</span>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <button class="add-row-btn">＋ Select another battery</button> -->
        </div>
      </div>
    </div>
  </div>

  <div style="height: 20px;"></div>

  <!-- ══════════════════════════════════════ -->
  <!-- SECTION 4, 5, 6: COMPLIANCE & DEALER -->
  <!-- ══════════════════════════════════════ -->
  <div class="three-col-sections">

    <!-- POLLUTION -->
    <div class="section-card" style="margin-bottom:0;">
      <div class="section-header">
        <div class="section-title">
          <div class="section-icon pollution">🌿</div>
          <div>
            <h2>PUC Details </h2>
            <div class="section-subtitle">PUC certificate info</div>
          </div>
        </div>
        <span class="section-badge badge-optional">Optional</span>
      </div>
      <div class="section-body">
        <div class="form-grid" style="gap:12px;">

          <div class="field">
            <label class="field-label">PUC Via <span class="required-dot">*</span></label>
            <div class="">
                <ng-select appendTo="body" formControlName="pollutionId" placeholder="Select " class="field-input filled">
                    <ng-option *ngFor="let item of pollutionVendorList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>
            </div>

            <!-- Brand & Model (auto-populated) -->
            <div class="field">
                <label class="field-label">PUC ID <span class="required-dot">*</span></label>
                <div class="field-input">
                    <input type="text" trim="blur" class="input" formControlName="pollutionNumber"  />
                </div>
            </div>

            <div class="form-grid grid-2" style="gap:10px;">
                <div class="field">
                    <label class="field-label">Valid From <span class="required-dot">*</span></label>
                    <div class="field-input">
                        <p-calendar appendTo="body" class="mfgDate"  dateFormat="dd/mm/yy"  formControlName="pollutionValidityFrom" [maxDate]="maxDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2035"></p-calendar>
                    </div>
                </div>
                <div class="field">
                    <label class="field-label">Valid Till <span class="required-dot">*</span></label>
                    <div class="field-input">
                        <p-calendar appendTo="body" class="mfgDate"  dateFormat="dd/mm/yy"  formControlName="pollutionValidityTill" [minDate]="jobForm.get('pollutionValidityFrom')?.value"  [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2035"></p-calendar>
                    </div>
                </div>
            </div>

            
          



          <div class="field">
            <label class="field-label">Upload PUC (PDF, JPG, PNG) <span class="required-dot">*</span></label>
            <div class="file-upload">
              <div class="file-icon">📄</div>
              <div class="file-text">
                <input type="file" id="uploads" name="uploads" (change)="selectFile($event,'Pollution')" accept=".xlsx, .xls" #uploadPollutionInput>
              </div>
              <div class="uploadFile" *ngIf="pollutionUploadUrl != null && pollutionUploadUrl != ''">
                <span class="file-icon">
                  <svg fill="#000000" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" class="icon">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path d="M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"></path>
                        </g>
                      </svg>
                  </span>
                <a class="clossfile" (click)="removeFile('Pollution')"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="p-dialog-header-close-icon p-icon" aria-hidden="true"><path d="M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z" fill="currentColor"></path></svg></a>
              </div>
            </div> 
          </div>

        </div>
      </div>
    </div>

    <!-- INSURANCE -->
    <div class="section-card" style="margin-bottom:0;">
      <div class="section-header">
        <div class="section-title">
          <div class="section-icon insurance">🛡️</div>
          <div>
            <h2>Insurance Details</h2>
            <div class="section-subtitle">Active policy info</div>
          </div>
        </div>
        <span class="section-badge badge-optional">Optional</span>
      </div>
      <div class="section-body">
        <div class="form-grid" style="gap:12px;">
         <div class="field">
            <label class="field-label">Insurer Name <span class="required-dot">*</span></label>
            <div class="">
                <ng-select appendTo="body" formControlName="insurerId" placeholder="Select " class="field-input filled">
                    <ng-option *ngFor="let item of insuranceList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>
          </div>

        <div class="field">
            <label class="field-label">Insurance Number <span class="required-dot">*</span></label>
            <div class="field-input">
                <input type="text" trim="blur" class="input" formControlName="insuranceNumber"  />
            </div>
        </div>
          <div class="form-grid grid-2" style="gap:10px;">
             <div class="field">
                <label class="field-label">Valid From <span class="required-dot">*</span></label>
                <div class="field-input">
                    <p-calendar appendTo="body" class="mfgDate"  formControlName="insuranceValidityFrom" dateFormat="dd/mm/yy" [maxDate]="maxDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2035"></p-calendar>
                </div>
            </div>
            <div class="field">
                <label class="field-label">Valid Till <span class="required-dot">*</span></label>
                <div class="field-input">
                    <p-calendar appendTo="body" class="mfgDate" formControlName="insuranceValidityTill"  [minDate]="jobForm.get('insuranceValidityFrom')?.value"  dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2035"></p-calendar>
                </div>
            </div>
          </div>
          <div class="field">
            <label class="field-label">Upload Insurance (PDF, JPG, PNG) <span class="required-dot">*</span></label>
            <div class="file-upload">
              <div class="file-icon">📄</div>
              <div class="file-text">
                <input type="file" id="uploads" name="uploads" (change)="selectFile($event,'Insurance')" accept=".xlsx, .xls" #uploadInsuranceInput>
              </div>
              <div class="uploadFile" *ngIf="insuranceUploadUrl != null && insuranceUploadUrl != ''">
                <span class="file-icon">
                  <svg fill="#000000" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" class="icon">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path d="M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"></path>
                        </g>
                      </svg>
                  </span>
                <a class="clossfile" (click)="removeFile('Insurance')"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="p-dialog-header-close-icon p-icon" aria-hidden="true"><path d="M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z" fill="currentColor"></path></svg></a>
              </div>
            </div> 
          </div>
        </div>
      </div>
    </div>

    <!-- DEALER -->
    <div class="section-card" style="margin-bottom:0;">
      <div class="section-header">
        <div class="section-title">
          <div class="section-icon dealer">🏪</div>
          <div>
            <h2>Dealer Details</h2>
            <div class="section-subtitle">Servicing Dealer info</div>
          </div>
        </div>
        <span class="section-badge badge-optional">Optional</span>
      </div>
      <div class="section-body">
        <div class="form-grid" style="gap:12px;">
          <div class="field">
          <label class="field-label">Dealer Code <span class="required-dot">*</span></label>
          <div class="">
            <ng-select (change)="onVendorhange($event)" appendTo="body" formControlName="vendorId" placeholder="Select " class="field-input filled">
                <ng-option *ngFor="let item of vendorsList" [value]="item.id">{{item.vendorCode}}</ng-option>
            </ng-select>
          </div>
        </div>
          <div class="field">
            <label class="field-label">Dealer Name <span class="required-dot">*</span></label>
            <div class="field-input">
                <input class="read-only-field"  type="text" trim="blur" class="input" formControlName="vendorName"  />
            </div>
        </div>
            <div class="form-grid grid-2" style="gap:10px;">
             <div class="field">
                <label class="field-label">Valid From <span class="required-dot">*</span></label>
                <div class="field-input">
                    <p-calendar appendTo="body" class="mfgDate"  dateFormat="dd/mm/yy" formControlName="vendorValidityFrom" [maxDate]="maxDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2035"></p-calendar>

                </div>
            </div>
            <div class="field">
                <label class="field-label">Valid Till <span class="required-dot">*</span></label>
                <div class="field-input">
                    <p-calendar appendTo="body" class="mfgDate"  dateFormat="dd/mm/yy" formControlName="vendorValidityTill"  [minDate]="jobForm.get('vendorValidityFrom')?.value"  [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2035"></p-calendar>
                </div>
            </div>
          </div>
          <div class="field">
            <label class="field-label">Upload Document(Agreement, contract, etc.) <span class="required-dot">*</span></label>
            <div class="file-upload">
              <div class="file-icon">📄</div>
              <div class="file-text">
                <input type="file" id="uploads" name="uploads" (change)="selectFile($event,'VENDOR')" accept=".xlsx, .xls" #uploadVendorInput>
              </div>
              <div class="uploadFile" *ngIf="vendorUploadUrl != null && vendorUploadUrl != ''">
                <span class="file-icon">
                  <svg fill="#000000" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" class="icon">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path d="M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"></path>
                        </g>
                      </svg>
                  </span>
                <a class="clossfile" (click)="removeFile('VENDOR')"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="p-dialog-header-close-icon p-icon" aria-hidden="true"><path d="M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z" fill="currentColor"></path></svg></a>
              </div>
            </div> 
          </div>
        </div>
      </div>
    </div>

  </div>

  <div style="height: 80px;"></div>

</div>

<!-- CTA FOOTER -->
<div class="cta-footer">
  <div class="cta-left">
    <div class="cta-stat">
      Truck Tyres: <span class="cta-stat-val" style="color:var(--green)">{{selectedTyre.length}}/{{selectedTruck?.tyreCapacity}}</span>
    </div>
    <div class="cta-stat">
      Batteries: <span class="cta-stat-val" style="color:var(--orange)">{{selectedBatteries.length}}/{{selectedTruck?.batteryCapacity}}</span>
    </div>
    <div class="cta-stat">
     Trailer Tyres: <span class="cta-stat-val" style="color:var(--green)">{{selectedTyreTrailer.length}}/{{selectedTrailer?.trailerTyreCapacity}}</span>
    </div>
    <!-- <div class="cta-stat">
      Status: <span class="cta-stat-val" style="color:var(--orange)">Draft</span>
    </div> -->
  </div>
  
  <div class="cta-right">
    <button class="btn btn-ghost" (click)="closeDialog()">← Back</button>
    <button class="btn btn-draft" (click)="submitAssembly('draft')" >💾 Save Draft</button>
    <button class="btn btn-primary" (click)="submitAssembly('save')" [disabled]="jobForm.invalid">Submit Assembly →</button>
  </div>
</div>
</div>